import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedTemplate: null,
};

export const examTemplateSlice = createSlice({
  name: 'examTemplate',
  initialState,
  reducers: {
    setSelectedTemplate: (state, action) => {
      state.selectedTemplate = action.payload;
    },
  },
});

export const { setSelectedTemplate } = examTemplateSlice.actions;

export const selectSelectedTemplate = (state) => state.examTemplate.selectedTemplate;

export default examTemplateSlice.reducer;

